/* global connect React Component */
import mixins from "../mixins";
export class CompanyInfo extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct.bind(this)("CompanyInfo");
    this.state = {
      links:mixins.links||[],
      rowcount: 0,
      tableData: [],
      columns: [
        {
          title: "Client Name",
          dataIndex: "clientName",
          hasFilter: true
        },
        {
          title: "Client ID",
          dataIndex: "clientId",
        },
        {
          title: "Email ID",
          dataIndex: "emailId",
        },
        {
          title: "Mobile No.",
          dataIndex: "mobileNumber",
          sorter: (a, b) => a.mobileNumber - b.mobileNumber,
          hasFilter: true
        },
        {
          title: "Join Date",
          dataIndex: "joinDate",
        },
        {
          title: "Entity Name",
          dataIndex: "companyName",
          sorter: (a, b) => a.companyName - b.companyName,
          hasFilter: true,
          type: 'select',
          options: [
            { label: "ALL", key: "" },
          ],
          className: "select-focus"
        },
        {
          title: "Location",
          dataIndex: "location",
        }
      ]
    }
  }

  onPageChange() {

  }

  editAction() {

  }

  deleteAction() {

  }

  onSearch() {

  }

  render() {
    const breadCumRight = () => (
      <div className="col-auto float-end ml-auto">
        <a href="#" className="btn add-btn" data-bs-toggle="modal" data-bs-target="#appModal">
          <i className="fa fa-plus"></i> Add Client
        </a>
        {/* <div className="view-icons">
          <a className="grid-view btn btn-link" href="/app/employees/clients">
            <i className="fa fa-th"></i>
          </a>
          <a className="list-view btn btn-link active" href="/app/employees/clients/personal-info">
            <i className="fa fa-bars"></i>
          </a>
        </div> */}
      </div>
    );
    let { tableData, columns, rowcount,links } = this.state;
    return <AppWrapper title="Clients" slots={{ breadCumRight }}>
      <AppLinkTabs data={links} ></AppLinkTabs>
      <AppForm className="row filter-row" ref="form">
        {columns.filter(o => o.hasFilter).map((o, i) => (
          <div className="col" key={o.name + '' + i} >
            <AppInputFocus
              type={o.type || 'text'}
              name={o.name}
              label={o.title}
              {...Object.only(o, ['className', 'options'])}
              className={o.className || ''}
            >
            </AppInputFocus>
          </div>
        ))}
        <div className="col">
          <button
            className="btn btn-warning btn-block w-100"
            onClick={() => this.onSearch()}
          >
            Search
          </button>
        </div>
      </AppForm>
      <div className="row mb-4">
        <div className="col">
          <AppTable
            data={tableData}
            columns={columns}
            reorder={true}
            onChange={(...arg) => this.onPageChange(...arg)}
            total={rowcount}
            editAction={(data) => this.editAction(data)}
            deleteAction={(data) => this.deleteAction(data)}
            pageSize={10}
          ></AppTable>
        </div>
      </div>
    </AppWrapper>;
  }
}

export default connect(CompanyInfo);
